

import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink, useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Card, Container, Fab, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { fetcheditableinspection, fetchinspectionCategory, getqualitymaterialcode, fetchequipmentdetailsdetails, fetchqualitydetails, fetchinspectordetails, editInspectionList } from './qualityApi';
import loader from '../../images/loader.gif';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { SubmitIcon } from '../../common/icons';
function EditInspectionPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [fetchinspectiondetails, setFetchInspectionDetails] = useState([]);
    const [fetchCategorydetails, setFetchCategoryDetails] = useState([]);
    const [allMaterialCode, setAllMaterialCode] = useState([]);
    const [allEquipmentDetails, setAllEquipmentDetails] = useState([]);
    const [qualityParamDetails, setQualityParamDetails] = useState([]);
    const [finalEditInspection, setFinalEditInspection] = useState([]);
    // const [isLoading, setLoading] = useState(true);
    const [fetchdetails, setFetchDetails] = useState({
        id: '',
        inspectionorderId: '',
        inspectDescription: ' ',
        categoryOfInspection: '',
        createdBy: '',
        inspectorName: '',
        inspectorEmail: '',
        inspectorContact: '',
        qualityparam: '',
        materialCode: '',
        inspectionEquipmentUsed: '',
        status: '',
        dateOfInspection: '',
        inspectionLocationType: '',
        inspectionStorageLocation: '',
        lotNumber: '',
        triggeringReason: '',
        surprisecheck: '',
        requesterName: '',
        createdDate: '',
        measuredQuantity: '',
        actualQuantity: '',
        grievenceNumber: '',
        createdOn: ''

    });
    const [details, setDetails] = useState({
        id: '',
        inspectionorderId: '',
        inspectDescription: '',
        categoryOfInspection: '',
        createdBy: '',
        inspectorName: '',
        inspectorEmail: '',
        inspectorContact: '',
        qualityparam: '',
        materialCode: '',
        inspectionEquipmentUsed: '',
        status: '',
        dateOfInspection: '',
        inspectionLocationType: '',
        inspectionStorageLocation: '',
        lotNumber: '',
        triggeringReason: '',
        surprisecheck: ''
    });
    const [inspectorDetails, setInspectorDetails] = useState([]);
    // const [quaParamArr, setQuaParamArr] = useState([]);
    const [quaParaArray, setQuaParaArray] = useState([]);
    useEffect(() => {
        // fetcheditableinspection(id, setFetchInspectionDetails, setLoading, setQuaParamArr)
        fetcheditableinspection(id, setFetchInspectionDetails)
    }, []);
    useEffect(() => {
        fetchinspectionCategory(setFetchCategoryDetails)
    }, []);
    useEffect(() => {
        if (fetchinspectiondetails) {
            setFetchDetails({
                ...fetchdetails, id: fetchinspectiondetails?.id, inspectionorderId: fetchinspectiondetails?.inspectionOrderId, inspectDescription: fetchinspectiondetails?.inspectDescription,
                categoryOfInspection: fetchinspectiondetails?.categoryOfInspection,
                createdBy: fetchinspectiondetails?.createdBy,
                inspectorName: fetchinspectiondetails?.inspectorName,
                inspectorEmail: fetchinspectiondetails?.inspectorEmail,
                inspectorContact: fetchinspectiondetails?.inspectorContactNo,
                materialCode: fetchinspectiondetails?.materialCode,
                inspectionEquipmentUsed: fetchinspectiondetails?.inspectionEquipmentUsed,
                status: fetchinspectiondetails?.status,
                dateOfInspection: fetchinspectiondetails?.dateOfInspection,
                inspectionLocationType: fetchinspectiondetails?.inspectionLocationType,
                inspectionStorageLocation: fetchinspectiondetails?.inspectionStorageLocation,
                lotNumber: fetchinspectiondetails?.lotNumber,
                triggeringReason: fetchinspectiondetails?.triggeringReason,
                surprisecheck: fetchinspectiondetails?.surprise === true ? "Yes" : "No",
                requesterName: fetchinspectiondetails?.requesterName,
                createdDate: fetchinspectiondetails?.createdDate,
                measuredQuantity: fetchinspectiondetails?.measuredQuantity,
                actualQuantity: fetchinspectiondetails?.actualQuantity,
                grievenceNumber: fetchinspectiondetails?.grievenceNumber,
                createdOn: fetchinspectiondetails?.createdOn
            })
        }
        setQuaParaArray(fetchinspectiondetails?.bundleIdEntity)
    }, [fetchinspectiondetails]);
    useEffect(() => {
        getqualitymaterialcode(setAllMaterialCode)
    }, []);
    useEffect(() => {
        fetchequipmentdetailsdetails(setAllEquipmentDetails)
    }, []);
    useEffect(() => {
        fetchqualitydetails(setQualityParamDetails)
    }, []);
    useEffect(() => {
        fetchinspectordetails(setInspectorDetails)
    }, []);
    useEffect(() => {
        if ((finalEditInspection?.statusCde === '100')) {
            setDetails([])
            setFetchDetails([])
            setQuaParaArray();
            // navigate('/qualitydashboard/inspectionworkorder')
        }
    }, [finalEditInspection]);
    const handleChange = (e) => {
        if (e.target.name === "inspectorName") {
            let result_details = e.target.value.split("*")
            setDetails({ ...details, inspectorName: result_details[0], inspectorEmail: result_details[1], inspectorContact: result_details[2] })
            setFetchDetails({ ...fetchdetails, inspectorName: '', inspectorEmail: '', inspectorContact: '' })
        }
        else {
            setDetails({ ...details, [e.target.name]: e.target.value })
            setFetchDetails({ ...fetchdetails, [e.target.name]: '' })
        }
    }
    const handleDateChange = (e) => {
        setDetails({ ...details, "dateOfInspection": e.format("YYYY-MM-DD") });
    }
    const onSubmitEditInspection = (e) => {
        e.preventDefault();
        const checkstatus = details?.surprisecheck ? (details?.surprisecheck === 'Yes' ? true : false) : (fetchdetails?.surprisecheck === 'Yes' ? true : false)
        editInspectionList(id, details, fetchdetails, checkstatus, quaParaArray, setFinalEditInspection, navigate)
    }
    return (
        <>
            <Helmet>
                <title> Edit Inspection | ABEPL </title>
            </Helmet>
            {/* {(isLoading) ?
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
                    <img src={loader} alt="loading..." />
                </div>
                : */}
                <Container maxWidth="xl">
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        <Fab component={RouterLink} to='/qualitydashboard/inspectionworkorder' size="small" aria-label="back" title='Back'>
                            <KeyboardArrowLeftRounded />
                        </Fab>  Edit Inspection Work Order
                    </Typography>
                    <Card sx={{ paddingLeft: '4%' }}>
                        <Stack spacing={2} sx={{ pt: 1 }}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                                <TextField fullWidth
                                    disabled
                                    variant="filled"
                                    label="Subject"
                                    name="inspectDescription"
                                    value={details?.inspectDescription ? details?.inspectDescription : fetchdetails?.inspectDescription ? fetchdetails?.inspectDescription : ''}
                                    onChange={(e) => handleChange(e)}
                                    sx={{ paddingRight: '3%' }}
                                />
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                    <InputLabel id="categoryinspection-label">Category of inspection</InputLabel>
                                    <Select
                                        label="Category of inspection"
                                        disabled
                                        variant="filled"
                                        name="categoryOfInspection"
                                        value={details?.categoryOfInspection ? details?.categoryOfInspection : fetchdetails?.categoryOfInspection ? fetchdetails?.categoryOfInspection : ''}
                                        onChange={(e) => handleChange(e)}
                                    >
                                        <MenuItem><em>Select</em></MenuItem>
                                        {
                                            fetchCategorydetails?.Inspection_category?.map((categorylist) =>
                                                <MenuItem key={categorylist} value={categorylist}>{categorylist}</MenuItem>

                                            )}
                                    </Select>
                                </FormControl>
                                <TextField fullWidth
                                    disabled
                                    id="outlined-required"
                                    label="RequesterName"
                                    name="createdBy"
                                    value={details?.createdBy ? details?.createdBy : fetchdetails?.createdBy ? fetchdetails?.createdBy : ''}
                                    onChange={(e) => handleChange(e)}
                                    variant="filled"
                                    sx={{ paddingRight: '3%' }}
                                />
                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                                <TextField fullWidth
                                    disabled
                                    label="Inspection equipment used"
                                    labelId="equipment-label"
                                    id="inspectionEquipmentUsed"
                                    name="inspectionEquipmentUsed"
                                    value={details?.inspectionEquipmentUsed ? details?.inspectionEquipmentUsed : fetchdetails?.inspectionEquipmentUsed ? fetchdetails?.inspectionEquipmentUsed : ''}
                                    onChange={(e) => handleChange(e)}
                                    variant="filled"
                                    sx={{ paddingRight: '3%' }}
                                />
                                <TextField fullWidth
                                    disabled
                                    id="outlined-required"
                                    label="Created date"
                                    name="Created date"
                                    value={details?.createdStr ? details?.createdStr : fetchinspectiondetails?.createdStr ? fetchinspectiondetails?.createdStr : ''}
                                    variant="filled"
                                    sx={{ paddingRight: '3%' }}
                                />
                                <TextField fullWidth
                                    disabled
                                    label="Status"
                                        name="status"
                                    value={details?.status ? details?.status : fetchdetails?.status ? fetchdetails?.status : ''}
                                    variant="filled"
                                    sx={{ paddingRight: '3%' }}
                                />
                                {/* <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                    <InputLabel id="categoryinspection-label">Status</InputLabel>
                                    <Select
                                        label="Status"
                                        name="status"
                                        value={details?.status ? details?.status : fetchdetails?.status ? fetchdetails?.status : ''}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem><em>Select</em></MenuItem>
                                        <MenuItem key="Open" value="Open">Open</MenuItem>
                                        <MenuItem key="WIP" value="WIP">WIP</MenuItem>
                                        <MenuItem key="Closed" value="Closed">Closed</MenuItem>
                                    </Select>
                                </FormControl> */}
                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            label="Date of Inspection"
                                            inputFormat="DD/MM/YYYY"
                                            value={details?.dateOfInspection ? details?.dateOfInspection : fetchdetails?.dateOfInspection ? fetchdetails?.dateOfInspection : ''}
                                            onChange={(e) => { handleDateChange(e) }}
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                        /></LocalizationProvider>
                                </FormControl>
                                <TextField fullWidth
                                    disabled
                                    variant="filled"
                                    id="outlined-required"
                                    label="Inspection Location Type"
                                    name="inspectionLocationType"
                                    value={details?.inspectionLocationType ? details?.inspectionLocationType : fetchdetails?.inspectionLocationType ? fetchdetails?.inspectionLocationType : ''}
                                    onChange={(e) => handleChange(e)}
                                    sx={{ paddingRight: '3%' }}
                                />
                                <TextField fullWidth
                                    disabled
                                    variant="filled"
                                    label="Inspection Storage location Location"
                                    name="inspectionStorageLocation"
                                    value={details?.inspectionStorageLocation ? details?.inspectionStorageLocation : fetchdetails?.inspectionStorageLocation ? fetchdetails?.inspectionStorageLocation : ''}
                                    onChange={(e) => handleChange(e)}
                                    sx={{ paddingRight: '3%' }}
                                />

                            </Stack>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
                                <TextField fullWidth
                                    disabled
                                    label="Lot Number"
                                    name="lotNumber"
                                    variant="filled"
                                    value={details?.lotNumber ? details?.lotNumber : fetchdetails?.lotNumber ? fetchdetails?.lotNumber : ''}
                                    onChange={(e) => handleChange(e)}
                                    sx={{ paddingRight: '3%' }}
                                />
                                <TextField fullWidth
                                    disabled
                                    label="Triggering Reason"
                                    name="triggeringReason"
                                    variant="filled"
                                    value={details?.triggeringReason ? details?.triggeringReason : fetchdetails?.triggeringReason ? fetchdetails?.triggeringReason : ''}
                                    sx={{ paddingRight: '3%' }}
                                />
                                <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                    <InputLabel id="categoryinspection-label">Surprise</InputLabel>
                                    <Select
                                        label="Surprise"
                                        disabled
                                        variant="filled"
                                        value={details?.surprisecheck ? details?.surprisecheck : fetchdetails?.surprisecheck ? fetchdetails?.surprisecheck : ''}
                                        onChange={(e) => handleChange(e)}
                                        name="surprisecheck">
                                        <MenuItem><em>Select</em></MenuItem>
                                        <MenuItem key="Yes" value="Yes">Yes</MenuItem>
                                        <MenuItem key="No" value="No">No</MenuItem>
                                    </Select>
                                </FormControl>
                            </Stack>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 2 }}>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}>
                                <InputLabel id="select-inspector-list-label">Inspector</InputLabel>
                                <Select
                                    label="Inspector"
                                    name="inspectorName"
                                    value={details?.inspectorName ? details?.inspectorName + '*' + details?.inspectorEmail + '*' + details?.inspectorContact : fetchdetails?.inspectorName ? fetchdetails?.inspectorName + '*' + fetchdetails?.inspectorEmail + '*' + fetchdetails?.inspectorContact : ''}
                                    onChange={(e) => handleChange(e)}>
                                    <MenuItem><em>Select</em></MenuItem>
                                    {
                                        inspectorDetails?.map((inspectorlist) =>
                                            <MenuItem value={inspectorlist?.firstname + '*' + inspectorlist?.emailAddress + '*' + inspectorlist?.mobileNo}>{inspectorlist?.firstname}</MenuItem>
                                        )}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}></FormControl>
                            <FormControl sx={{ width: '100%', paddingRight: '3%' }}></FormControl>
                        </Stack>
                        &nbsp;
                        &nbsp;
                        <Box display='flex' alignItems="center" justifyContent="center">
                            <Button sx={{ minWidth: 120 }} variant="contained" onClick={(e) => onSubmitEditInspection(e)} endIcon={<SubmitIcon />}>Submit</Button>
                        </Box>
                        &nbsp;
                        &nbsp;
                    </Card>
                </Container>
            {/* } */}
        </>
    )
}

export default EditInspectionPage